import * as React from 'react';
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import Translate from '../../common/functions/translate';
import Dialog from '@material-ui/core/Dialog';
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import * as Modal from '../../common/components/modal/modalDialog';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';
import OfferService from '../../services/offerService';
import Spinner from '../../common/components/spinner/spinner';
import Snackbar from "../../common/components/snackbar/snackbar";
import { OfferAdminModel } from "../../models/offer/offerAdminModel";
import { DropdownModel } from '../../models/dropdownModel';
import * as HelperFunctions from '../../common/functions/helperFunctions';
import { OfferStatus, Units, FileSystemType } from "../../common/enums";
import { ClientModel } from "../../models/clientModel";
import UserService from '../../services/userService';
import { UserDropdownModel } from '../../models';
import AuthService from '../../services/authService';
import { FileModel } from "../../models/fileModel";
import Paper from '@material-ui/core/Paper';
import FileService from '../../services/fileService';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Link from '@material-ui/core/Link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarked } from '@fortawesome/free-solid-svg-icons';

interface IProps {
  closeAddEditOfferModal: any,
  cancelClick: any,
  saveClick: any,
  isVisible: boolean,
  currentOffer: OfferAdminModel,
}

interface IState {
  offer: OfferAdminModel,
  validationMessage: string,
  isLoading: boolean,
  offerStatuses: Array<DropdownModel>,
  usersDropdown: Array<DropdownModel>,
  activeIndex: number;
  selectedFile: FileModel;
  isVisibleFileConfirmDialog: boolean;
  readonly: boolean;
}

const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      marginNormal: {
        marginTop: 5,
        marginBottom: 0,
        width: '100%'
      },
      root: {
        width: '100%'
      }
    },
    MuiFormControlLabel: {
      root: {
        marginLeft: '0px'
      }
    },
    MuiDialog: {
      paper: {
        margin: 0,
        maxWidth: '90% !important'
      },
      paperFullWidth: {
        width: '1000px'
      }
    },
  },
  palette: {
    primary: blue
  }
})

enum TabIndexes {
  OfferInfo = 0,
  OfferFiles = 1
}

class OfferAddEditDialog extends React.Component<IProps, IState> {
  snackbar: any;
  authService = new AuthService();
  offerService = new OfferService();
  userService = new UserService();
  fileService = new FileService();

  refFile: any;
  currentFile: FileModel;

  constructor(props: IProps) {
    super(props);

    this.state = {
      offer: props.currentOffer,
      validationMessage: '',
      isLoading: false,
      offerStatuses: new Array<DropdownModel>(0),
      usersDropdown: new Array<DropdownModel>(0),
      activeIndex: TabIndexes.OfferInfo,
      selectedFile: new FileModel(),
      isVisibleFileConfirmDialog: false,
      readonly: false,
    };
  }

  componentDidMount() {
    let offerStatuses: Array<DropdownModel> = [];
    let readonly = false;

    if (this.authService.checkIsRegionalManager() || this.authService.checkIsTrader()) {
      if (this.props.currentOffer.offerStatusId === OfferStatus.New) {
        offerStatuses = offerStatuses.concat(HelperFunctions.enumToDropdownArray(OfferStatus, true)
          .filter(c => c.value === OfferStatus.Accepted || c.value === this.state.offer.offerStatusId));
      } else if (this.props.currentOffer.offerStatusId === OfferStatus.Expired) {
        offerStatuses = offerStatuses.concat(HelperFunctions.enumToDropdownArray(OfferStatus, true)
          .filter(c => c.value === OfferStatus.New || c.value === this.state.offer.offerStatusId));
      } else {
        offerStatuses = offerStatuses.concat(HelperFunctions.enumToDropdownArray(OfferStatus, true)
          .filter(c => c.value === this.state.offer.offerStatusId));
        readonly = this.authService.checkIsTrader() ? true : false;
      }
    } else {
      offerStatuses = offerStatuses.concat(HelperFunctions.enumToDropdownArray(OfferStatus, true)
        .filter(c => c.value === OfferStatus.InExecution || c.value === OfferStatus.Finished || c.value === this.state.offer.offerStatusId));
    }

    this.setState({
      isLoading: true,
      offerStatuses,
      readonly
    });

    this.initUsersDropdown();
  }

  initUsersDropdown = () => {

    if (this.authService.checkIsTrader()) {
      this.setState({
        isLoading: false,
      });
      return;
    }

    let regionId, roleId = 4;
    if (this.authService.checkIsRegionalManager()) {
      regionId = this.authService.getUserRegionId();
      //roleId = 4;
    }

    this.userService.getUsersByRegionAndRole(regionId, roleId).then(
      (data: any) => {
        let usersDropdown = new Array<DropdownModel>(0);
        data.forEach(r => usersDropdown.push({ label: r.name, value: r.userId, additionalData: r.phone }));
        this.setState({
          isLoading: false,
          usersDropdown: usersDropdown
        });
      })
      .catch(error => {
        this.snackbar.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  handleChange = (key, value) => {
    if (key === 'offerDiscount' && value > 100) {
      return;
    }

    if ((key === 'offerDiscount' || key === 'fixedDiscount') && !value) {
      value = 0;
    }

    const offer: OfferAdminModel = { ...this.state.offer };
    offer[key] = value;
    this.setState({ offer: { ...offer } });
  };

  //TODO: ask about validation
  isValidAddEditForm() {
    let message = '';

    const { offer } = this.state;
    let trader = { ...offer.trader }

    if (!offer.trader || !trader.userId) {
      message += Translate('Choose trader');
    }

    if (message) {
      this.snackbar.show({ severity: 'error', summary: message });
    }

    return message === '';
  }

  handleSaveButton = (event, close) => {
    event.preventDefault();

    if (!this.isValidAddEditForm()) return;

    this.props.saveClick(this.state.offer, close);
  };

  handleCancelButton = () => {
    this.props.cancelClick();
  }

  //TODO: Add checks for these funcs for prop values before adding coma
  returnClientData = (client: ClientModel) => {
    if (client) {
      return client.name + ', ' + client.town + ', ' + client.address;
    }
    return '';
  }

  handleAutocompleteChange = (e, newValue) => {
    const offer: OfferAdminModel = { ...this.state.offer };

    if (newValue) {
      if (!offer.trader)
        offer.trader = new UserDropdownModel();

      offer.trader.name = newValue.label;
      offer.trader.userId = newValue.value;
      offer.trader.phone = newValue.additionalData;
    }
    else {
      offer.trader = new UserDropdownModel();
    }

    this.setState({ offer: { ...offer } });
  }

  //TODO: ParseInt for fileSize 
  //TODo: file system type after dropdown

  //TODO: file system type, not needed here for download or check

  handleFileRemoveClick = (e, selectedFile) => {
    e.preventDefault();
    this.setState({
      isVisibleFileConfirmDialog: true,
      selectedFile: selectedFile
    });
  }

  handleDownloadFileClick = (event, id: number, fileName: string, fileSystemTypeId: number) => {
    event.stopPropagation();

    this.setState({ isLoading: true });
    this.fileService.getFileContent(id)
      .then(
        (data) => {
          this.setState({ isLoading: false });
          let contentType = fileSystemTypeId === FileSystemType.BillOfQuantities || fileSystemTypeId === FileSystemType.BillOfQuantitiesLabor
            ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            : 'application/pdf';
          const linkSource = `data:${contentType};base64,${data.data.fileContent}`;
          const downloadLink = document.createElement("a");
          downloadLink.setAttribute('href', linkSource);
          downloadLink.download = `${fileName}.${fileSystemTypeId === FileSystemType.BillOfQuantities || fileSystemTypeId === FileSystemType.BillOfQuantitiesLabor ? 'xlsx' : 'pdf'}`;
          downloadLink.click();
        },
        error => {
          this.snackbar.show({ severity: 'error', summary: error.message });
          this.setState({
            isLoading: false
          });
        }
      );
  }

  tableSection = (rows, sectionName) => {
    return (
      <>
        <TableRow>
          <TableCell align="left" colSpan={5}>
            <strong>{Translate(sectionName)}</strong>
          </TableCell>
        </TableRow>
        {rows.map((row, index) => (
          <TableRow key={index + sectionName}>
            <TableCell component="th" scope="row">
              {row.articleNumber}
            </TableCell>
            <TableCell>{row.article}</TableCell>
            <TableCell align="right">{HelperFunctions.getEnumLabel(row.unitId, Units, true)}</TableCell>
            <TableCell align="right">{row.quantity}</TableCell>
            <TableCell align="right">{(row.price * row.quantity).toFixed(2) + " " + Translate('BGN')}</TableCell>
          </TableRow>
        ))}
      </>
    )
  }


  public render() {

    const { offer, isLoading, offerStatuses, usersDropdown } = this.state;

    let selectedTrader: DropdownModel | null = null;
    if (offer.trader && offer.trader.userId > 0) {
      selectedTrader = new DropdownModel();
      selectedTrader.label = offer.trader.name;
      selectedTrader.value = offer.trader.userId;
      selectedTrader.additionalData = offer.trader.phone;
    }

    let header = '';

    if (!offer.id) {
      header = Translate('AddOffer');
    } else {
      header = Translate('EditOffer');
    }

    let priceAfterDiscount = offer.offerDiscount ? offer.offerPrice - (offer.offerPrice * offer.offerDiscount / 100) : offer.offerPrice;
    priceAfterDiscount = offer.fixedDiscount ? priceAfterDiscount - offer.fixedDiscount : priceAfterDiscount;
    let vatPrice = priceAfterDiscount * 0.2;

    let discountAmount = offer.offerDiscount || offer.fixedDiscount ? offer.offerPrice - priceAfterDiscount : 0;

    return (
      <>
        <MuiThemeProvider theme={theme}>
          <Dialog
            open={this.props.isVisible}
            onClose={this.handleCancelButton}
            fullWidth
          >
            <Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelButton}>{header}</Modal.DialogTitle>
            <Modal.DialogContent>
              {isLoading ? <Spinner /> : null}
              <Snackbar ref={(el) => this.snackbar = el} />
              {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
              <div>
                <div style={{ display: 'flex' }}>
                  <Paper className="profile-card" style={{ marginBottom: "20px", padding: "20px", marginRight: "20px", maxWidth: "600px", width: "50%" }}>
                    <div>
                      <div className="profile-card-item" style={{ display: "flex" }}>
                        <div>
                          {Translate('Number')}: <strong>{offer.offerNumber}</strong>
                        </div>
                        <div style={{ margin: "7px 10px", fontSize: "0.8em" }}>
                          <span style={HelperFunctions.getOfferStatusColor(offer.offerStatusId)}>
                            {HelperFunctions.getEnumLabel(offer.offerStatusId, OfferStatus, true)}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: 'row', alignItems: "flex-start" }}>
                      <div style={{ minWidth: "200px", marginRight: "40px" }}>
                        <div className="profile-card-item" style={{ borderBottom: "1px solid #aaa" }}>
                          <div>
                            <strong>{Translate('Client')}</strong>
                          </div>
                        </div>
                        <div className="profile-card-item">
                          <div>
                            {Translate('Name')}:
                          </div>
                          <div>
                            <strong>{offer.client ? offer.client.name : ''}</strong>
                          </div>
                        </div>
                        <div className="profile-card-item">
                          <div>
                            {Translate('Email')}:
                          </div>
                          <div>
                            <strong>{offer.client ? offer.client.email : ''}</strong>
                          </div>
                        </div>
                        <div className="profile-card-item">
                          <div>
                            {Translate('Phone')}:
                          </div>
                          <div>
                            <strong>{offer.client ? offer.client.phone : ''}</strong>
                          </div>
                        </div>
                      </div>

                      <div style={{ minWidth: "200px", marginRight: "20px" }}>
                        <div className="profile-card-item" style={{ borderBottom: "1px solid #aaa" }}>
                          <div>
                            <strong>{Translate('Address')}</strong>
                          </div>
                        </div>
                        <div className="profile-card-item">
                          <div>
                            {Translate('Disctrict')}:
                          </div>
                          <div>
                            <strong>{offer.client ? offer.client.disctrict : ''}</strong>
                          </div>
                        </div>
                        <div className="profile-card-item">
                          <div>
                            {Translate('City')}:
                          </div>
                          <div>
                            <strong>{offer.client ? offer.client.town : ''}</strong>
                          </div>
                        </div>
                        <div className="profile-card-item">
                          <div>
                            {Translate('Address')}:
                          </div>
                          <div>
                            <strong>{offer.client ? offer.client.address : ''}</strong>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      {this.state.offer.client && this.state.offer.client.locationLatitude && this.state.offer.client.locationLongitude
                        ? <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5 }}>
                          <Link href={`https://maps.google.com/?q=${this.state.offer.client.locationLatitude},${this.state.offer.client.locationLongitude}`}
                            target="_blank"
                            style={{ marginLeft: "10px" }}>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                              <FontAwesomeIcon icon={faMapMarked} style={{ fontSize: "30px", marginRight: "5px" }} />
                              <span style={{ marginTop: 10 }}>{this.state.offer.client.locationLatitude}, {this.state.offer.client.locationLongitude}</span>
                            </div>
                          </Link>
                        </div>
                        : null}
                    </div>
                  </Paper>

                  <Paper className="profile-card" style={{ marginBottom: "20px", padding: "10px", marginRight: "20px", maxWidth: "600px", width: "50%" }}>
                    <div style={{ padding: 10 }}>
                      {offer.offerFiles && offer.offerFiles.length > 0 ?
                        offer.offerFiles.map((o: FileModel, index) =>
                          <div key={o.fileId ? o.fileId + 'doc' : index + 'temp'}
                            style={{ display: "flex", marginRight: "20px", cursor: "pointer", padding: "5px" }} className="on-hover"
                            onClick={(e) => this.handleDownloadFileClick(e, o.fileId, o.fileName, o.fileSystemTypeId)}>
                            <div style={{ paddingRight: '10px' }}>
                              <img src={HelperFunctions.getIconByFileType(o.fileType)} style={{ height: "42px" }} alt="pdf"></img>
                            </div>
                            <div>
                              <div>
                                {o.fileName}
                              </div>
                              <div style={{ color: '#999', fontSize: '.9em' }}>
                                {HelperFunctions.formatBytes(o.fileSizeInBytes, 0)} | {o.fileSystemTypeId === FileSystemType.BillOfQuantities || o.fileSystemTypeId === FileSystemType.BillOfQuantitiesLabor ? 'XLSX' : 'PDF'}
                              </div>
                            </div>
                          </div>
                        ) : null}
                    </div>
                  </Paper>
                </div>
                <TableContainer component={Paper} style={{ maxHeight: "600px" }}>
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell><strong>{Translate("Number")}</strong></TableCell>
                        <TableCell><strong>{Translate("Article")}</strong></TableCell>
                        <TableCell style={{ width: 80 }} align="right"><strong>{Translate("UnitShort")}</strong></TableCell>
                        <TableCell style={{ width: 80 }} align="right"><strong>{Translate("Qty")}</strong></TableCell>
                        <TableCell style={{ width: 150 }} align="right"><strong>{Translate("Price without VAT")}</strong></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>

                      {offer.gasInstallProducts && offer.gasInstallProducts.length > 0 ?
                        this.tableSection(offer.gasInstallProducts, "GasInstallation")
                        : null}

                      {offer.gasAdditionalProducts && offer.gasAdditionalProducts.length > 0 ?
                        this.tableSection(offer.gasAdditionalProducts, "Services and materials")
                        : null}

                      {offer.heathInstallProducts && offer.heathInstallProducts.length > 0 ?
                        this.tableSection(offer.heathInstallProducts, "HeatingInstallation")
                        : null}

                      {offer.heathAdditionalProducts && offer.heathAdditionalProducts.length > 0 ?
                        this.tableSection(offer.heathAdditionalProducts, "Services and materials")
                        : null}

                      <TableRow>
                        <TableCell colSpan={4} align="right">
                          <div>{Translate("Total without VAT")}</div>
                          {offer.offerDiscount || offer.fixedDiscount ? <div>{Translate('Discount amount without VAT')}</div> : null}
                          {offer.offerDiscount || offer.fixedDiscount ? <div>{Translate("Total after discount")}</div> : null}
                          <div>{Translate("VAT")}</div>
                        </TableCell>
                        <TableCell align="right">
                          <div>{offer.offerPrice.toFixed(2) + " " + Translate('BGN')}</div>
                          {offer.offerDiscount || offer.fixedDiscount ? <div>{discountAmount.toFixed(2) + " " + Translate('BGN')}</div> : null}
                          {offer.offerDiscount || offer.fixedDiscount ? <div>{priceAfterDiscount.toFixed(2) + " " + Translate('BGN')}</div> : null}
                          <div>{vatPrice.toFixed(2) + " " + Translate('BGN')}</div>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan={4} align="right"><span style={{ fontWeight: 600 }}>{Translate("Total with VAT")}</span></TableCell>
                        <TableCell align="right"><span style={{ fontWeight: 600 }}>{(vatPrice + priceAfterDiscount).toFixed(2) + " " + Translate('BGN')}</span></TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                {offer.adminNotes || offer.disclaimer
                  ? <Paper style={{ marginTop: 20 }}>
                    <div style={{ padding: 10 }}>
                      <div>
                        {offer.adminNotes ?
                          <p>{offer.adminNotes}</p>
                          : null}
                      </div>
                      <div>
                        {offer.disclaimer ?
                          <div>
                            <label style={{ fontWeight: 600 }}>{Translate("Disclaimer")}</label>
                            <div style={{ fontSize: 14 }}>{offer.disclaimer}</div>
                          </div>
                          : null}
                      </div>
                    </div>
                  </Paper>
                  : null}

                {offer.statusHistory && offer.statusHistory.length > 0
                  ? <ExpansionPanel style={{ marginTop: 20 }}>
                    <ExpansionPanelSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <div>{`${Translate('Status changes')} (${offer.statusHistory.length})`}</div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <Table stickyHeader size="small" style={{ marginTop: -10 }}>
                        <TableHead>
                          <TableRow>
                            <TableCell><strong>{Translate('Date')}</strong></TableCell>
                            <TableCell><strong>{Translate('Status')}</strong></TableCell>
                            <TableCell><strong>{Translate('User')}</strong></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {offer.statusHistory.map((s, i) => {
                            return (
                              <TableRow key={i}>
                                <TableCell>
                                  {HelperFunctions.fomatDateTimeAsString(new Date(s.date))}
                                </TableCell>
                                <TableCell>
                                  {HelperFunctions.getEnumLabel(s.statusId, OfferStatus, true)}
                                </TableCell>
                                <TableCell>
                                  {s.user ? s.user : Translate('Changed by system')}
                                </TableCell>
                              </TableRow>
                            )
                          })}
                        </TableBody>
                      </Table>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  : null}
                <Paper style={{ margin: '20px 0px', display: 'flex', flexDirection: 'row', padding: 15 }}>
                  <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                    {!this.authService.checkIsTrader() ?
                      <div style={{ display: 'flex', flexDirection: 'row', marginTop: 15, width: '200px' }}>
                        <div style={{ width: '100%', marginRight: 10 }}>
                          <Autocomplete
                            disabled={offer.offerStatusId === OfferStatus.Finished}
                            options={usersDropdown}
                            getOptionLabel={option => option.label}
                            value={selectedTrader}
                            onChange={(e, newValue) => this.handleAutocompleteChange(e, newValue)}
                            renderInput={params => (
                              <TextField
                                {...params}
                                label={Translate('Trader')}
                                placeholder={Translate('TraderName')}
                                fullWidth
                              />
                            )}
                          />
                        </div>
                      </div>
                      : null
                    }

                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: 15, width: '200px' }}>
                      <div style={{ width: "100%", marginRight: 10 }}>
                        <FormControl>
                          <InputLabel htmlFor="offer-status-label">{Translate("Status")}</InputLabel>
                          <Select
                            value={offer.offerStatusId ? offer.offerStatusId : ''}
                            disabled={this.state.readonly}
                            onChange={(e) => this.handleChange('offerStatusId', e.target.value)}
                            inputProps={{
                              id: 'offer-status-label'
                            }}
                          >
                            {
                              offerStatuses.map(m => <MenuItem key={m.value + 'status'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                            }
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                    <div style={{ marginTop: 15, marginRight: 10, width: 200 }}>
                      <TextField
                        name="fixedDiscount"
                        label={Translate("Discount (BGN)")}
                        type="number"
                        onChange={(e) => this.handleChange('fixedDiscount', e.target['value'])}
                        value={offer && offer.fixedDiscount ? offer.fixedDiscount : ""}
                        disabled={!this.authService.checkIsRegionalManager() || (offer.offerStatusId !== OfferStatus.New)}
                      />
                    </div>
                    <div style={{ marginTop: 15, width: 200 }}>
                      <TextField
                        name="offerDiscount"
                        label={Translate("Discount")}
                        type="number"
                        onChange={(e) => this.handleChange('offerDiscount', e.target['value'])}
                        value={offer && offer.offerDiscount ? offer.offerDiscount : ""}
                        disabled={!this.authService.checkIsRegionalManager() || (offer.offerStatusId !== OfferStatus.New)}
                      />
                    </div>
                  </div>
                </Paper>
              </div>
            </Modal.DialogContent>
            <Modal.DialogActions>
              <div>
                <Button onClick={this.handleCancelButton} variant="contained" style={{ marginRight: 10 }}>
                  {Translate("Cancel")}
                </Button>
                {!this.state.readonly
                  ? <Button onClick={(e) => this.handleSaveButton(e, true)} color="primary" variant="contained" style={{ marginRight: 10 }}>
                    {Translate("Save")}
                  </Button>
                  : null}
                {!this.state.readonly
                  ? <Button onClick={(e) => this.handleSaveButton(e, false)} color="secondary" variant="contained">
                    {Translate("Save & Close")}
                  </Button>
                  : null}
              </div>
            </Modal.DialogActions>
          </Dialog >
        </MuiThemeProvider >
      </>
    )
  }
}

export default OfferAddEditDialog;